import { Tool } from './tool-card';

export const tools: Tool[] = [
  {
    name: 'RRM',
    link: 'https://rrm.mcd.com/otpStores/e1579193',
    description:
      'Remote Restaurant Manager is a tool used to run queries and tasks on technology equipment within an McDonalds Restaurant.',
    tags: ['Rrm', 'McDonalds'],
  },
  {
    name: 'TRT',
    link: 'https://trt.mcd.com/',
    description:
      'Technology Reinvestment Tool is used to view the specific software any piece of hardware is currently running.',
  },
  {
    name: 'AWE',
    link: 'https://network.mcd.com/',
    description:
      'The AWE Portal allows OTP’s to view and troubleshoot Network related items.',
    tags: ['Awe', 'Network'],
  },
  {
    name: 'VHQ',
    link: 'https://vhqmcdgui.verifone.com/',
    description:
      'Verifone HQ is used to troubleshoot cashless payments and payment related items.',
    tags: ['Vhq', 'Verifone'],
  },
  {
    name: 'ServiceNow',
    link: 'https://atostransform.service-now.com/external_logout_complete.do',
    description: 'ServiceNow is the ticketing system for ATOS.',
  },
  {
    name: 'Sherlock',
    link: 'https://sherlock.mcd.com/',
    description: 'Uses call data from Service Now to create a dashboard.',
  },
  {
    name: 'Cerebro',
    link: 'https://otp.mcd.com/cerebro/',
    description:
      'Results of deployments and restaurant readiness for upcoming deployments.',
    tags: ['Cerebro', 'McDonalds', 'OTP 2&3'],
  },
];
